export default __webpack_public_path__ + "static/media/icon-our-goal.73e70944.svg";